var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":_vm.viewBox,"fill":_vm.fill}},[_c('path',{attrs:{"d":"M9.79102 1.65381H11.7539L8.70703 15.9995H6.74414L9.79102 1.65381Z","fill":_vm.stroke}})])
}
var staticRenderFns = []

export { render, staticRenderFns }